<script lang="ts">
import { onMount } from "svelte";
import { pushReferrals } from "../../helpers/referrals";


    export let message: string
    export let details: string

    export let hash = ""

    onMount(() => {
        try {
            pushReferrals(hash)
        } catch (err) {
            console.error(err)
        }
    })
</script>

<h3 class="modal_heading">
    <i class="fas fa-glass-cheers"></i>
    Transaction Sent
</h3>
<p class="modal_p white_text">
    {message}
</p>
{#if details}
    <pre class="modal_p white_text">
        {details}
    </pre>
{/if}

<style>
    h3 {
        margin-top: 0px;
    }

    pre {
        background-color: var(--button-color);
        color: var(--button-text-color);
        padding: 10px;
        border-radius: var(--border-radius);
    }
</style>

